export default __webpack_public_path__ + "static/media/personalization_blue.ab07caa0.svg";